import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "type", "id", "children", "style", "url", "shouldOpenNewTab", "title"];
import React from 'react';
import pt from 'prop-types';
import { Element } from '../';
import { appendHtmlClass, extendProps } from '../../js/util';
import './_index.scss';
var LINK_TYPE = {
  default: 'default',
  underlined: 'underlined',
  raw: 'raw'
};
var DEFAULT_LINK_TYPE = LINK_TYPE.default;
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    type = props.type,
    id = props.id,
    children = props.children,
    style = props.style,
    url = props.url,
    shouldOpenNewTab = props.shouldOpenNewTab,
    title = props.title,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var newProps = {};
  var renderAs = props['as'];
  newProps.className = type !== DEFAULT_LINK_TYPE ? appendHtmlClass(className, type) : className;
  if (id) newProps.id = id;
  if (style) newProps.style = style;
  if (url) newProps.href = url;
  if (title) newProps.title = title;
  if (shouldOpenNewTab) newProps.target = '_blank';
  newProps = Object.assign(rest, newProps);
  if (!renderAs) {
    return /*#__PURE__*/React.createElement(Element, Object.assign({
      as: "a"
    }, newProps), children);
  } else {
    var Type = renderAs.type;
    var inheritProps = renderAs.inheritProps;
    if (inheritProps) {
      var propsToInherit = {};
      if (inheritProps === true) {
        propsToInherit = newProps;
      } else if (typeof inheritProps === 'object') {
        for (var name in inheritProps) {
          if (!inheritProps.hasOwnProperty(name) || !inheritProps[name] || !newProps.hasOwnProperty(name)) continue;
          var newName = inheritProps[name] === true ? name : inheritProps[name];
          propsToInherit[newName] = newProps[name];
        }
      }
      newProps = propsToInherit;
    }
    if (typeof renderAs.props == 'object') {
      newProps = Object.assign(newProps, renderAs.props);
    }
    return /*#__PURE__*/React.createElement(Type, Object.assign({}, newProps, {
      ref: ref
    }), children);
  }
});
Object.assign(Link, extendProps(Element, ['className', 'id', 'children', 'style', 'isAnimated'], {
  /**
   * React component used to render link instead of HTML <a> element. Use ```props``` object to specify additional props for this component and ```inheritProps``` set to ```true``` to inherit
   * all <a> properties such as ```href``` or ```className```. You can use ```inheritProps``` as an object to map <a> props into different names e.g. ```{ href: 'to' }```.
   */
  as: pt.exact({
    type: pt.elementType.isRequired,
    props: pt.object,
    inheritProps: pt.oneOfType([pt.bool, pt.shape({
      href: pt.oneOfType([pt.bool, pt.string]),
      className: pt.oneOfType([pt.bool, pt.string]),
      title: pt.oneOfType([pt.bool, pt.string]),
      target: pt.oneOfType([pt.bool, pt.string]),
      style: pt.oneOfType([pt.bool, pt.string]),
      id: pt.oneOfType([pt.bool, pt.string]),
      onClick: pt.oneOfType([pt.bool, pt.func])
    })])
  }),
  /**
   * Style type of link: default or underlined
   */
  type: pt.oneOf(Object.values(LINK_TYPE)),
  /**
   * URL to link resource
   */
  url: pt.string,
  /**
   * Link title
   */
  title: pt.string,
  /**
   * Whether link should be opened in separate browser tab
   */
  shouldOpenNewTab: pt.bool
}, {
  type: DEFAULT_LINK_TYPE,
  shouldOpenNewTab: false
}));
export default Link;